import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';

@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.css']
})
export class InformationComponent implements OnInit {
  userInfo: any;
  VendorInfos: any;
  isShowOrgFields = false;
  public userRestrictionData:any={};
  public subModOfInformation:any=[];
  public showInfoMods:boolean=false;

  constructor(
    public storage: StorageService,
    public api: ApiService) 
  {
    this.userInfo = this.storage.get('userInfo');
    const obj = {
      orgID: this.userInfo.orgID
    };
    this.api.org_settingsList(obj).then((res: any) => {
      this.showInfoMods=true;
        let mail=this.userInfo.userEmail;
        let selectedUser=res.data['userInfo'].filter(e=> e.userEmail==mail);
        this.userInfo['fieldMap']=selectedUser[0]['fieldMap'];
        this.storage.setData({ userInfo: this.userInfo });
        let user = this.userInfo;
        if(user && user['fieldMap']){
          this.userRestrictionData=user['fieldMap'];
          let subModulesOfInformation=Object.keys(this.userRestrictionData['Information'].menu1);
          for(let i=0;i<subModulesOfInformation.length;i++){
            if(this.userRestrictionData && (this.userRestrictionData['Information'].checked || this.userRestrictionData['Information'].indeterminate) && this.userRestrictionData['Information'].menu1 && this.userRestrictionData['Information'].menu1[subModulesOfInformation[i]] && (this.userRestrictionData['Information'].menu1[subModulesOfInformation[i]].checked || this.userRestrictionData['Information'].menu1[subModulesOfInformation[i]].indeterminate)){
              this.subModOfInformation.push(subModulesOfInformation[i]);
            }
          }
        }
    }).catch((err) => {
        console.log(err);
    });

  }

  ngOnInit(): void {
  //  this.getVenderData()
  }

}
